// AUTO-GENERATED by scripts/compute-fantasy-extras.py — do not edit by hand.

export type WeeklyRow = {
  event: number
  team: string
  manager: string
  opponent: string
  pointsFor: number
  pointsAgainst: number
  result: string
}

export type TeamMVP = {
  player: string
  code: string | null
  loadBearingWins: number
  totalPoints: number
  weeksRostered: number
}

export const weeklyScores: WeeklyRow[] = [
  {
    event: 1,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Real Manhattan',
    pointsFor: 33,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 1,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Chunky jeet FC',
    pointsFor: 44,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 1,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Big Micha',
    pointsFor: 23,
    pointsAgainst: 67,
    result: 'L',
  },
  {
    event: 1,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Hookah Doncic',
    pointsFor: 67,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 1,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'fent folders',
    pointsFor: 24,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 1,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Son Doku',
    pointsFor: 39,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 1,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Old Lady',
    pointsFor: 45,
    pointsAgainst: 57,
    result: 'L',
  },
  {
    event: 1,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'wadeland',
    pointsFor: 57,
    pointsAgainst: 45,
    result: 'W',
  },
  {
    event: 1,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Leyverpool',
    pointsFor: 23,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 1,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Yanited',
    pointsFor: 44,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 1,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'A',
    pointsFor: 40,
    pointsAgainst: 42,
    result: 'L',
  },
  {
    event: 1,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'AVERAGE',
    pointsFor: 42,
    pointsAgainst: 40,
    result: 'W',
  },
  {
    event: 1,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 47,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 1,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'MBOOMO',
    pointsFor: 39,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 2,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'MBOOMO',
    pointsFor: 25,
    pointsAgainst: 28,
    result: 'L',
  },
  {
    event: 2,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Real Manhattan',
    pointsFor: 28,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 2,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'AVERAGE',
    pointsFor: 31,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 2,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 36,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 2,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Yanited',
    pointsFor: 25,
    pointsAgainst: 25,
    result: 'D',
  },
  {
    event: 2,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'A',
    pointsFor: 25,
    pointsAgainst: 25,
    result: 'D',
  },
  {
    event: 2,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'wadeland',
    pointsFor: 55,
    pointsAgainst: 43,
    result: 'W',
  },
  {
    event: 2,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Leyverpool',
    pointsFor: 43,
    pointsAgainst: 55,
    result: 'L',
  },
  {
    event: 2,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Son Doku',
    pointsFor: 49,
    pointsAgainst: 49,
    result: 'D',
  },
  {
    event: 2,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Old Lady',
    pointsFor: 49,
    pointsAgainst: 49,
    result: 'D',
  },
  {
    event: 2,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Hookah Doncic',
    pointsFor: 44,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 2,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'fent folders',
    pointsFor: 31,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 2,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Chunky jeet FC',
    pointsFor: 21,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 2,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Big Micha',
    pointsFor: 44,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 3,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Real Manhattan',
    pointsFor: 23,
    pointsAgainst: 30,
    result: 'L',
  },
  {
    event: 3,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Hookah Doncic',
    pointsFor: 30,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 3,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Chunky jeet FC',
    pointsFor: 49,
    pointsAgainst: 53,
    result: 'L',
  },
  {
    event: 3,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Son Doku',
    pointsFor: 53,
    pointsAgainst: 49,
    result: 'W',
  },
  {
    event: 3,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Big Micha',
    pointsFor: 51,
    pointsAgainst: 44,
    result: 'W',
  },
  {
    event: 3,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'wadeland',
    pointsFor: 44,
    pointsAgainst: 51,
    result: 'L',
  },
  {
    event: 3,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'fent folders',
    pointsFor: 36,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 3,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Yanited',
    pointsFor: 44,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 3,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Old Lady',
    pointsFor: 38,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 3,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'AVERAGE',
    pointsFor: 29,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 3,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Leyverpool',
    pointsFor: 38,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 3,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'MBOOMO',
    pointsFor: 30,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 3,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'A',
    pointsFor: 31,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 3,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 39,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 4,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 41,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 4,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Real Manhattan',
    pointsFor: 30,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 4,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'MBOOMO',
    pointsFor: 55,
    pointsAgainst: 50,
    result: 'W',
  },
  {
    event: 4,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'A',
    pointsFor: 50,
    pointsAgainst: 55,
    result: 'L',
  },
  {
    event: 4,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'AVERAGE',
    pointsFor: 48,
    pointsAgainst: 43,
    result: 'W',
  },
  {
    event: 4,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Leyverpool',
    pointsFor: 43,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 4,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Yanited',
    pointsFor: 33,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 4,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Old Lady',
    pointsFor: 23,
    pointsAgainst: 33,
    result: 'L',
  },
  {
    event: 4,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'wadeland',
    pointsFor: 65,
    pointsAgainst: 48,
    result: 'W',
  },
  {
    event: 4,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'fent folders',
    pointsFor: 48,
    pointsAgainst: 65,
    result: 'L',
  },
  {
    event: 4,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Son Doku',
    pointsFor: 46,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 4,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Big Micha',
    pointsFor: 37,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 4,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Hookah Doncic',
    pointsFor: 53,
    pointsAgainst: 35,
    result: 'W',
  },
  {
    event: 4,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Chunky jeet FC',
    pointsFor: 35,
    pointsAgainst: 53,
    result: 'L',
  },
  {
    event: 5,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Real Manhattan',
    pointsFor: 24,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 5,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Son Doku',
    pointsFor: 47,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 5,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Hookah Doncic',
    pointsFor: 33,
    pointsAgainst: 28,
    result: 'W',
  },
  {
    event: 5,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'wadeland',
    pointsFor: 28,
    pointsAgainst: 33,
    result: 'L',
  },
  {
    event: 5,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Chunky jeet FC',
    pointsFor: 25,
    pointsAgainst: 42,
    result: 'L',
  },
  {
    event: 5,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Yanited',
    pointsFor: 42,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 5,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Big Micha',
    pointsFor: 34,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 5,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'AVERAGE',
    pointsFor: 27,
    pointsAgainst: 34,
    result: 'L',
  },
  {
    event: 5,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'fent folders',
    pointsFor: 39,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 5,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'MBOOMO',
    pointsFor: 36,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 5,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Old Lady',
    pointsFor: 26,
    pointsAgainst: 31,
    result: 'L',
  },
  {
    event: 5,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 31,
    pointsAgainst: 26,
    result: 'W',
  },
  {
    event: 5,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Leyverpool',
    pointsFor: 48,
    pointsAgainst: 47,
    result: 'W',
  },
  {
    event: 5,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'A',
    pointsFor: 47,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 6,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'A',
    pointsFor: 63,
    pointsAgainst: 40,
    result: 'W',
  },
  {
    event: 6,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Real Manhattan',
    pointsFor: 40,
    pointsAgainst: 63,
    result: 'L',
  },
  {
    event: 6,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 41,
    pointsAgainst: 22,
    result: 'W',
  },
  {
    event: 6,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Leyverpool',
    pointsFor: 22,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 6,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'MBOOMO',
    pointsFor: 36,
    pointsAgainst: 28,
    result: 'W',
  },
  {
    event: 6,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Old Lady',
    pointsFor: 28,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 6,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'AVERAGE',
    pointsFor: 22,
    pointsAgainst: 33,
    result: 'L',
  },
  {
    event: 6,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'fent folders',
    pointsFor: 33,
    pointsAgainst: 22,
    result: 'W',
  },
  {
    event: 6,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Yanited',
    pointsFor: 27,
    pointsAgainst: 26,
    result: 'W',
  },
  {
    event: 6,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Big Micha',
    pointsFor: 26,
    pointsAgainst: 27,
    result: 'L',
  },
  {
    event: 6,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'wadeland',
    pointsFor: 30,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 6,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Chunky jeet FC',
    pointsFor: 38,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 6,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Son Doku',
    pointsFor: 30,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 6,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Hookah Doncic',
    pointsFor: 36,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 7,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Real Manhattan',
    pointsFor: 56,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 7,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'wadeland',
    pointsFor: 38,
    pointsAgainst: 56,
    result: 'L',
  },
  {
    event: 7,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Son Doku',
    pointsFor: 36,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 7,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Yanited',
    pointsFor: 37,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 7,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Hookah Doncic',
    pointsFor: 37,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 7,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'AVERAGE',
    pointsFor: 21,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 7,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Chunky jeet FC',
    pointsFor: 27,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 7,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'MBOOMO',
    pointsFor: 36,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 7,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Big Micha',
    pointsFor: 31,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 7,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 44,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 7,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'fent folders',
    pointsFor: 30,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 7,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'A',
    pointsFor: 36,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 7,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Old Lady',
    pointsFor: 66,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 7,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Leyverpool',
    pointsFor: 31,
    pointsAgainst: 66,
    result: 'L',
  },
  {
    event: 8,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Leyverpool',
    pointsFor: 38,
    pointsAgainst: 26,
    result: 'W',
  },
  {
    event: 8,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Real Manhattan',
    pointsFor: 26,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 8,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'A',
    pointsFor: 30,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 8,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Old Lady',
    pointsFor: 38,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 8,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 64,
    pointsAgainst: 19,
    result: 'W',
  },
  {
    event: 8,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'fent folders',
    pointsFor: 19,
    pointsAgainst: 64,
    result: 'L',
  },
  {
    event: 8,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'MBOOMO',
    pointsFor: 38,
    pointsAgainst: 20,
    result: 'W',
  },
  {
    event: 8,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Big Micha',
    pointsFor: 20,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 8,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'AVERAGE',
    pointsFor: 21,
    pointsAgainst: 34,
    result: 'L',
  },
  {
    event: 8,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Chunky jeet FC',
    pointsFor: 34,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 8,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Yanited',
    pointsFor: 40,
    pointsAgainst: 55,
    result: 'L',
  },
  {
    event: 8,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Hookah Doncic',
    pointsFor: 55,
    pointsAgainst: 40,
    result: 'W',
  },
  {
    event: 8,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'wadeland',
    pointsFor: 29,
    pointsAgainst: 33,
    result: 'L',
  },
  {
    event: 8,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Son Doku',
    pointsFor: 33,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 9,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Real Manhattan',
    pointsFor: 59,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 9,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Yanited',
    pointsFor: 36,
    pointsAgainst: 59,
    result: 'L',
  },
  {
    event: 9,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'wadeland',
    pointsFor: 38,
    pointsAgainst: 35,
    result: 'W',
  },
  {
    event: 9,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'AVERAGE',
    pointsFor: 35,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 9,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Son Doku',
    pointsFor: 50,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 9,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'MBOOMO',
    pointsFor: 41,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 9,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Hookah Doncic',
    pointsFor: 25,
    pointsAgainst: 31,
    result: 'L',
  },
  {
    event: 9,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 31,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 9,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Chunky jeet FC',
    pointsFor: 39,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 9,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'A',
    pointsFor: 38,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 9,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Big Micha',
    pointsFor: 46,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 9,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Leyverpool',
    pointsFor: 29,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 9,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'fent folders',
    pointsFor: 43,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 9,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Old Lady',
    pointsFor: 29,
    pointsAgainst: 43,
    result: 'L',
  },
  {
    event: 10,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Old Lady',
    pointsFor: 49,
    pointsAgainst: 34,
    result: 'W',
  },
  {
    event: 10,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Real Manhattan',
    pointsFor: 34,
    pointsAgainst: 49,
    result: 'L',
  },
  {
    event: 10,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Leyverpool',
    pointsFor: 49,
    pointsAgainst: 34,
    result: 'W',
  },
  {
    event: 10,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'fent folders',
    pointsFor: 34,
    pointsAgainst: 49,
    result: 'L',
  },
  {
    event: 10,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'A',
    pointsFor: 31,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 10,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Big Micha',
    pointsFor: 41,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 10,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 37,
    pointsAgainst: 32,
    result: 'W',
  },
  {
    event: 10,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Chunky jeet FC',
    pointsFor: 32,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 10,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'MBOOMO',
    pointsFor: 40,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 10,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Hookah Doncic',
    pointsFor: 23,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 10,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'AVERAGE',
    pointsFor: 39,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 10,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Son Doku',
    pointsFor: 37,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 10,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Yanited',
    pointsFor: 44,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 10,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'wadeland',
    pointsFor: 33,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 11,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Real Manhattan',
    pointsFor: 41,
    pointsAgainst: 61,
    result: 'L',
  },
  {
    event: 11,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'AVERAGE',
    pointsFor: 61,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 11,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Yanited',
    pointsFor: 39,
    pointsAgainst: 59,
    result: 'L',
  },
  {
    event: 11,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'MBOOMO',
    pointsFor: 59,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 11,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'wadeland',
    pointsFor: 66,
    pointsAgainst: 42,
    result: 'W',
  },
  {
    event: 11,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 42,
    pointsAgainst: 66,
    result: 'L',
  },
  {
    event: 11,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Son Doku',
    pointsFor: 27,
    pointsAgainst: 31,
    result: 'L',
  },
  {
    event: 11,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'A',
    pointsFor: 31,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 11,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Hookah Doncic',
    pointsFor: 32,
    pointsAgainst: 26,
    result: 'W',
  },
  {
    event: 11,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Leyverpool',
    pointsFor: 26,
    pointsAgainst: 32,
    result: 'L',
  },
  {
    event: 11,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Chunky jeet FC',
    pointsFor: 20,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 11,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Old Lady',
    pointsFor: 40,
    pointsAgainst: 20,
    result: 'W',
  },
  {
    event: 11,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Big Micha',
    pointsFor: 50,
    pointsAgainst: 40,
    result: 'W',
  },
  {
    event: 11,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'fent folders',
    pointsFor: 40,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 12,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'fent folders',
    pointsFor: 46,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 12,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Real Manhattan',
    pointsFor: 48,
    pointsAgainst: 46,
    result: 'W',
  },
  {
    event: 12,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Old Lady',
    pointsFor: 54,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 12,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Big Micha',
    pointsFor: 29,
    pointsAgainst: 54,
    result: 'L',
  },
  {
    event: 12,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Leyverpool',
    pointsFor: 45,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 12,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Chunky jeet FC',
    pointsFor: 33,
    pointsAgainst: 45,
    result: 'L',
  },
  {
    event: 12,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'A',
    pointsFor: 43,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 12,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Hookah Doncic',
    pointsFor: 25,
    pointsAgainst: 43,
    result: 'L',
  },
  {
    event: 12,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 29,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 12,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Son Doku',
    pointsFor: 48,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 12,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'MBOOMO',
    pointsFor: 36,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 12,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'wadeland',
    pointsFor: 46,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 12,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'AVERAGE',
    pointsFor: 38,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 12,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Yanited',
    pointsFor: 40,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 13,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Real Manhattan',
    pointsFor: 41,
    pointsAgainst: 32,
    result: 'W',
  },
  {
    event: 13,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Big Micha',
    pointsFor: 32,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 13,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'fent folders',
    pointsFor: 24,
    pointsAgainst: 49,
    result: 'L',
  },
  {
    event: 13,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Chunky jeet FC',
    pointsFor: 49,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 13,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Old Lady',
    pointsFor: 31,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 13,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Hookah Doncic',
    pointsFor: 24,
    pointsAgainst: 31,
    result: 'L',
  },
  {
    event: 13,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Leyverpool',
    pointsFor: 25,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 13,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Son Doku',
    pointsFor: 48,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 13,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'A',
    pointsFor: 21,
    pointsAgainst: 33,
    result: 'L',
  },
  {
    event: 13,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'wadeland',
    pointsFor: 33,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 13,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 18,
    pointsAgainst: 32,
    result: 'L',
  },
  {
    event: 13,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Yanited',
    pointsFor: 32,
    pointsAgainst: 18,
    result: 'W',
  },
  {
    event: 13,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'MBOOMO',
    pointsFor: 33,
    pointsAgainst: 54,
    result: 'L',
  },
  {
    event: 13,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'AVERAGE',
    pointsFor: 54,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 14,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Real Manhattan',
    pointsFor: 19,
    pointsAgainst: 55,
    result: 'L',
  },
  {
    event: 14,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Chunky jeet FC',
    pointsFor: 55,
    pointsAgainst: 19,
    result: 'W',
  },
  {
    event: 14,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Big Micha',
    pointsFor: 41,
    pointsAgainst: 51,
    result: 'L',
  },
  {
    event: 14,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Hookah Doncic',
    pointsFor: 51,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 14,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'fent folders',
    pointsFor: 58,
    pointsAgainst: 32,
    result: 'W',
  },
  {
    event: 14,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Son Doku',
    pointsFor: 32,
    pointsAgainst: 58,
    result: 'L',
  },
  {
    event: 14,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Old Lady',
    pointsFor: 45,
    pointsAgainst: 35,
    result: 'W',
  },
  {
    event: 14,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'wadeland',
    pointsFor: 35,
    pointsAgainst: 45,
    result: 'L',
  },
  {
    event: 14,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Leyverpool',
    pointsFor: 28,
    pointsAgainst: 34,
    result: 'L',
  },
  {
    event: 14,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Yanited',
    pointsFor: 34,
    pointsAgainst: 28,
    result: 'W',
  },
  {
    event: 14,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'A',
    pointsFor: 39,
    pointsAgainst: 19,
    result: 'W',
  },
  {
    event: 14,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'AVERAGE',
    pointsFor: 19,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 14,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 46,
    pointsAgainst: 56,
    result: 'L',
  },
  {
    event: 14,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'MBOOMO',
    pointsFor: 56,
    pointsAgainst: 46,
    result: 'W',
  },
  {
    event: 15,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'MBOOMO',
    pointsFor: 50,
    pointsAgainst: 46,
    result: 'W',
  },
  {
    event: 15,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Real Manhattan',
    pointsFor: 46,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 15,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'AVERAGE',
    pointsFor: 45,
    pointsAgainst: 43,
    result: 'W',
  },
  {
    event: 15,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 43,
    pointsAgainst: 45,
    result: 'L',
  },
  {
    event: 15,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Yanited',
    pointsFor: 23,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 15,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'A',
    pointsFor: 50,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 15,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'wadeland',
    pointsFor: 29,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 15,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Leyverpool',
    pointsFor: 40,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 15,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Son Doku',
    pointsFor: 48,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 15,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Old Lady',
    pointsFor: 50,
    pointsAgainst: 48,
    result: 'W',
  },
  {
    event: 15,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Hookah Doncic',
    pointsFor: 61,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 15,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'fent folders',
    pointsFor: 30,
    pointsAgainst: 61,
    result: 'L',
  },
  {
    event: 15,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Chunky jeet FC',
    pointsFor: 50,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 15,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Big Micha',
    pointsFor: 38,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 16,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Real Manhattan',
    pointsFor: 31,
    pointsAgainst: 57,
    result: 'L',
  },
  {
    event: 16,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Hookah Doncic',
    pointsFor: 57,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 16,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Chunky jeet FC',
    pointsFor: 36,
    pointsAgainst: 32,
    result: 'W',
  },
  {
    event: 16,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Son Doku',
    pointsFor: 32,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 16,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Big Micha',
    pointsFor: 44,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 16,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'wadeland',
    pointsFor: 37,
    pointsAgainst: 44,
    result: 'L',
  },
  {
    event: 16,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'fent folders',
    pointsFor: 32,
    pointsAgainst: 43,
    result: 'L',
  },
  {
    event: 16,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Yanited',
    pointsFor: 43,
    pointsAgainst: 32,
    result: 'W',
  },
  {
    event: 16,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Old Lady',
    pointsFor: 39,
    pointsAgainst: 49,
    result: 'L',
  },
  {
    event: 16,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'AVERAGE',
    pointsFor: 49,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 16,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Leyverpool',
    pointsFor: 37,
    pointsAgainst: 32,
    result: 'W',
  },
  {
    event: 16,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'MBOOMO',
    pointsFor: 32,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 16,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'A',
    pointsFor: 39,
    pointsAgainst: 39,
    result: 'D',
  },
  {
    event: 16,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 39,
    pointsAgainst: 39,
    result: 'D',
  },
  {
    event: 17,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 51,
    pointsAgainst: 14,
    result: 'W',
  },
  {
    event: 17,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Real Manhattan',
    pointsFor: 14,
    pointsAgainst: 51,
    result: 'L',
  },
  {
    event: 17,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'MBOOMO',
    pointsFor: 35,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 17,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'A',
    pointsFor: 27,
    pointsAgainst: 35,
    result: 'L',
  },
  {
    event: 17,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'AVERAGE',
    pointsFor: 37,
    pointsAgainst: 35,
    result: 'W',
  },
  {
    event: 17,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Leyverpool',
    pointsFor: 35,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 17,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Yanited',
    pointsFor: 62,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 17,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Old Lady',
    pointsFor: 30,
    pointsAgainst: 62,
    result: 'L',
  },
  {
    event: 17,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'wadeland',
    pointsFor: 29,
    pointsAgainst: 32,
    result: 'L',
  },
  {
    event: 17,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'fent folders',
    pointsFor: 32,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 17,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Son Doku',
    pointsFor: 38,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 17,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Big Micha',
    pointsFor: 25,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 17,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Hookah Doncic',
    pointsFor: 36,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 17,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Chunky jeet FC',
    pointsFor: 39,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 18,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Real Manhattan',
    pointsFor: 30,
    pointsAgainst: 52,
    result: 'L',
  },
  {
    event: 18,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Son Doku',
    pointsFor: 52,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 18,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Hookah Doncic',
    pointsFor: 29,
    pointsAgainst: 28,
    result: 'W',
  },
  {
    event: 18,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'wadeland',
    pointsFor: 28,
    pointsAgainst: 29,
    result: 'L',
  },
  {
    event: 18,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Chunky jeet FC',
    pointsFor: 45,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 18,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Yanited',
    pointsFor: 39,
    pointsAgainst: 45,
    result: 'L',
  },
  {
    event: 18,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Big Micha',
    pointsFor: 34,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 18,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'AVERAGE',
    pointsFor: 21,
    pointsAgainst: 34,
    result: 'L',
  },
  {
    event: 18,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'fent folders',
    pointsFor: 42,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 18,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'MBOOMO',
    pointsFor: 50,
    pointsAgainst: 42,
    result: 'W',
  },
  {
    event: 18,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Old Lady',
    pointsFor: 25,
    pointsAgainst: 28,
    result: 'L',
  },
  {
    event: 18,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 28,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 18,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Leyverpool',
    pointsFor: 22,
    pointsAgainst: 42,
    result: 'L',
  },
  {
    event: 18,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'A',
    pointsFor: 42,
    pointsAgainst: 22,
    result: 'W',
  },
  {
    event: 19,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'A',
    pointsFor: 38,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 19,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Real Manhattan',
    pointsFor: 31,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 19,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 39,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 19,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Leyverpool',
    pointsFor: 30,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 19,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'MBOOMO',
    pointsFor: 43,
    pointsAgainst: 35,
    result: 'W',
  },
  {
    event: 19,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Old Lady',
    pointsFor: 35,
    pointsAgainst: 43,
    result: 'L',
  },
  {
    event: 19,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'AVERAGE',
    pointsFor: 35,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 19,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'fent folders',
    pointsFor: 36,
    pointsAgainst: 35,
    result: 'W',
  },
  {
    event: 19,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Yanited',
    pointsFor: 12,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 19,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Big Micha',
    pointsFor: 47,
    pointsAgainst: 12,
    result: 'W',
  },
  {
    event: 19,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'wadeland',
    pointsFor: 63,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 19,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Chunky jeet FC',
    pointsFor: 36,
    pointsAgainst: 63,
    result: 'L',
  },
  {
    event: 19,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Son Doku',
    pointsFor: 20,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 19,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Hookah Doncic',
    pointsFor: 48,
    pointsAgainst: 20,
    result: 'W',
  },
  {
    event: 20,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Real Manhattan',
    pointsFor: 39,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 20,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'wadeland',
    pointsFor: 27,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 20,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Son Doku',
    pointsFor: 31,
    pointsAgainst: 45,
    result: 'L',
  },
  {
    event: 20,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Yanited',
    pointsFor: 45,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 20,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Hookah Doncic',
    pointsFor: 37,
    pointsAgainst: 22,
    result: 'W',
  },
  {
    event: 20,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'AVERAGE',
    pointsFor: 22,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 20,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Chunky jeet FC',
    pointsFor: 57,
    pointsAgainst: 40,
    result: 'W',
  },
  {
    event: 20,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'MBOOMO',
    pointsFor: 40,
    pointsAgainst: 57,
    result: 'L',
  },
  {
    event: 20,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Big Micha',
    pointsFor: 39,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 20,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 37,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 20,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'fent folders',
    pointsFor: 49,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 20,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'A',
    pointsFor: 36,
    pointsAgainst: 49,
    result: 'L',
  },
  {
    event: 20,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Old Lady',
    pointsFor: 39,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 20,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Leyverpool',
    pointsFor: 24,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 21,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Leyverpool',
    pointsFor: 55,
    pointsAgainst: 58,
    result: 'L',
  },
  {
    event: 21,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Real Manhattan',
    pointsFor: 58,
    pointsAgainst: 55,
    result: 'W',
  },
  {
    event: 21,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'A',
    pointsFor: 17,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 21,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Old Lady',
    pointsFor: 41,
    pointsAgainst: 17,
    result: 'W',
  },
  {
    event: 21,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 41,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 21,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'fent folders',
    pointsFor: 47,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 21,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'MBOOMO',
    pointsFor: 21,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 21,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Big Micha',
    pointsFor: 38,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 21,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'AVERAGE',
    pointsFor: 56,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 21,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Chunky jeet FC',
    pointsFor: 39,
    pointsAgainst: 56,
    result: 'L',
  },
  {
    event: 21,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Yanited',
    pointsFor: 36,
    pointsAgainst: 28,
    result: 'W',
  },
  {
    event: 21,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Hookah Doncic',
    pointsFor: 28,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 21,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'wadeland',
    pointsFor: 26,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 21,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Son Doku',
    pointsFor: 47,
    pointsAgainst: 26,
    result: 'W',
  },
  {
    event: 22,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Real Manhattan',
    pointsFor: 38,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 22,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Yanited',
    pointsFor: 37,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 22,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'wadeland',
    pointsFor: 34,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 22,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'AVERAGE',
    pointsFor: 46,
    pointsAgainst: 34,
    result: 'W',
  },
  {
    event: 22,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Son Doku',
    pointsFor: 45,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 22,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'MBOOMO',
    pointsFor: 48,
    pointsAgainst: 45,
    result: 'W',
  },
  {
    event: 22,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Hookah Doncic',
    pointsFor: 21,
    pointsAgainst: 18,
    result: 'W',
  },
  {
    event: 22,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 18,
    pointsAgainst: 21,
    result: 'L',
  },
  {
    event: 22,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Chunky jeet FC',
    pointsFor: 33,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 22,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'A',
    pointsFor: 36,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 22,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Big Micha',
    pointsFor: 20,
    pointsAgainst: 20,
    result: 'D',
  },
  {
    event: 22,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Leyverpool',
    pointsFor: 20,
    pointsAgainst: 20,
    result: 'D',
  },
  {
    event: 22,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'fent folders',
    pointsFor: 50,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 22,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Old Lady',
    pointsFor: 33,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 23,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Old Lady',
    pointsFor: 50,
    pointsAgainst: 62,
    result: 'L',
  },
  {
    event: 23,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Real Manhattan',
    pointsFor: 62,
    pointsAgainst: 50,
    result: 'W',
  },
  {
    event: 23,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Leyverpool',
    pointsFor: 46,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 23,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'fent folders',
    pointsFor: 30,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 23,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'A',
    pointsFor: 27,
    pointsAgainst: 35,
    result: 'L',
  },
  {
    event: 23,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Big Micha',
    pointsFor: 35,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 23,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 33,
    pointsAgainst: 18,
    result: 'W',
  },
  {
    event: 23,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Chunky jeet FC',
    pointsFor: 18,
    pointsAgainst: 33,
    result: 'L',
  },
  {
    event: 23,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'MBOOMO',
    pointsFor: 24,
    pointsAgainst: 27,
    result: 'L',
  },
  {
    event: 23,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Hookah Doncic',
    pointsFor: 27,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 23,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'AVERAGE',
    pointsFor: 51,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 23,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Son Doku',
    pointsFor: 37,
    pointsAgainst: 51,
    result: 'L',
  },
  {
    event: 23,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Yanited',
    pointsFor: 43,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 23,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'wadeland',
    pointsFor: 47,
    pointsAgainst: 43,
    result: 'W',
  },
  {
    event: 24,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Real Manhattan',
    pointsFor: 37,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 24,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'AVERAGE',
    pointsFor: 41,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 24,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Yanited',
    pointsFor: 40,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 24,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'MBOOMO',
    pointsFor: 33,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 24,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'wadeland',
    pointsFor: 24,
    pointsAgainst: 42,
    result: 'L',
  },
  {
    event: 24,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 42,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 24,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Son Doku',
    pointsFor: 33,
    pointsAgainst: 57,
    result: 'L',
  },
  {
    event: 24,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'A',
    pointsFor: 57,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 24,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Hookah Doncic',
    pointsFor: 30,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 24,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Leyverpool',
    pointsFor: 38,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 24,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Chunky jeet FC',
    pointsFor: 50,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 24,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Old Lady',
    pointsFor: 38,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 24,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Big Micha',
    pointsFor: 41,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 24,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'fent folders',
    pointsFor: 25,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 25,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'fent folders',
    pointsFor: 52,
    pointsAgainst: 58,
    result: 'L',
  },
  {
    event: 25,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Real Manhattan',
    pointsFor: 58,
    pointsAgainst: 52,
    result: 'W',
  },
  {
    event: 25,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Old Lady',
    pointsFor: 54,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 25,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Big Micha',
    pointsFor: 33,
    pointsAgainst: 54,
    result: 'L',
  },
  {
    event: 25,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Leyverpool',
    pointsFor: 46,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 25,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Chunky jeet FC',
    pointsFor: 23,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 25,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'A',
    pointsFor: 23,
    pointsAgainst: 24,
    result: 'L',
  },
  {
    event: 25,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Hookah Doncic',
    pointsFor: 24,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 25,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 27,
    pointsAgainst: 20,
    result: 'W',
  },
  {
    event: 25,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Son Doku',
    pointsFor: 20,
    pointsAgainst: 27,
    result: 'L',
  },
  {
    event: 25,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'MBOOMO',
    pointsFor: 47,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 25,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'wadeland',
    pointsFor: 38,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 25,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'AVERAGE',
    pointsFor: 46,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 25,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Yanited',
    pointsFor: 37,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 26,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Real Manhattan',
    pointsFor: 41,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 26,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Big Micha',
    pointsFor: 33,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 26,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'fent folders',
    pointsFor: 38,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 26,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Chunky jeet FC',
    pointsFor: 41,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 26,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Old Lady',
    pointsFor: 43,
    pointsAgainst: 34,
    result: 'W',
  },
  {
    event: 26,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Hookah Doncic',
    pointsFor: 34,
    pointsAgainst: 43,
    result: 'L',
  },
  {
    event: 26,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Leyverpool',
    pointsFor: 37,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 26,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Son Doku',
    pointsFor: 50,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 26,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'A',
    pointsFor: 36,
    pointsAgainst: 69,
    result: 'L',
  },
  {
    event: 26,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'wadeland',
    pointsFor: 69,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 26,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 38,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 26,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Yanited',
    pointsFor: 25,
    pointsAgainst: 38,
    result: 'L',
  },
  {
    event: 26,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'MBOOMO',
    pointsFor: 39,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 26,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'AVERAGE',
    pointsFor: 29,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 27,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Real Manhattan',
    pointsFor: 28,
    pointsAgainst: 51,
    result: 'L',
  },
  {
    event: 27,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Chunky jeet FC',
    pointsFor: 51,
    pointsAgainst: 28,
    result: 'W',
  },
  {
    event: 27,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Big Micha',
    pointsFor: 56,
    pointsAgainst: 49,
    result: 'W',
  },
  {
    event: 27,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Hookah Doncic',
    pointsFor: 49,
    pointsAgainst: 56,
    result: 'L',
  },
  {
    event: 27,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'fent folders',
    pointsFor: 34,
    pointsAgainst: 42,
    result: 'L',
  },
  {
    event: 27,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Son Doku',
    pointsFor: 42,
    pointsAgainst: 34,
    result: 'W',
  },
  {
    event: 27,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Old Lady',
    pointsFor: 27,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 27,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'wadeland',
    pointsFor: 40,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 27,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Leyverpool',
    pointsFor: 57,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 27,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Yanited',
    pointsFor: 36,
    pointsAgainst: 57,
    result: 'L',
  },
  {
    event: 27,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'A',
    pointsFor: 40,
    pointsAgainst: 47,
    result: 'L',
  },
  {
    event: 27,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'AVERAGE',
    pointsFor: 47,
    pointsAgainst: 40,
    result: 'W',
  },
  {
    event: 27,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 32,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 27,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'MBOOMO',
    pointsFor: 29,
    pointsAgainst: 32,
    result: 'L',
  },
  {
    event: 28,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'MBOOMO',
    pointsFor: 31,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 28,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Real Manhattan',
    pointsFor: 37,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 28,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'AVERAGE',
    pointsFor: 15,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 28,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 36,
    pointsAgainst: 15,
    result: 'W',
  },
  {
    event: 28,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Yanited',
    pointsFor: 36,
    pointsAgainst: 43,
    result: 'L',
  },
  {
    event: 28,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'A',
    pointsFor: 43,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 28,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'wadeland',
    pointsFor: 57,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 28,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Leyverpool',
    pointsFor: 39,
    pointsAgainst: 57,
    result: 'L',
  },
  {
    event: 28,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Son Doku',
    pointsFor: 52,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 28,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Old Lady',
    pointsFor: 41,
    pointsAgainst: 52,
    result: 'L',
  },
  {
    event: 28,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Hookah Doncic',
    pointsFor: 43,
    pointsAgainst: 25,
    result: 'W',
  },
  {
    event: 28,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'fent folders',
    pointsFor: 25,
    pointsAgainst: 43,
    result: 'L',
  },
  {
    event: 28,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Chunky jeet FC',
    pointsFor: 24,
    pointsAgainst: 34,
    result: 'L',
  },
  {
    event: 28,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Big Micha',
    pointsFor: 34,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 29,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Real Manhattan',
    pointsFor: 41,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 29,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Hookah Doncic',
    pointsFor: 50,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 29,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Chunky jeet FC',
    pointsFor: 50,
    pointsAgainst: 69,
    result: 'L',
  },
  {
    event: 29,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Son Doku',
    pointsFor: 69,
    pointsAgainst: 50,
    result: 'W',
  },
  {
    event: 29,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Big Micha',
    pointsFor: 40,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 29,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'wadeland',
    pointsFor: 33,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 29,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'fent folders',
    pointsFor: 36,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 29,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Yanited',
    pointsFor: 41,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 29,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Old Lady',
    pointsFor: 40,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 29,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'AVERAGE',
    pointsFor: 31,
    pointsAgainst: 40,
    result: 'L',
  },
  {
    event: 29,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Leyverpool',
    pointsFor: 27,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 29,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'MBOOMO',
    pointsFor: 41,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 29,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'A',
    pointsFor: 30,
    pointsAgainst: 35,
    result: 'L',
  },
  {
    event: 29,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 35,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 30,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 23,
    pointsAgainst: 36,
    result: 'L',
  },
  {
    event: 30,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Real Manhattan',
    pointsFor: 36,
    pointsAgainst: 23,
    result: 'W',
  },
  {
    event: 30,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'MBOOMO',
    pointsFor: 36,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 30,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'A',
    pointsFor: 50,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 30,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'AVERAGE',
    pointsFor: 29,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 30,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Leyverpool',
    pointsFor: 39,
    pointsAgainst: 29,
    result: 'W',
  },
  {
    event: 30,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Yanited',
    pointsFor: 42,
    pointsAgainst: 42,
    result: 'D',
  },
  {
    event: 30,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Old Lady',
    pointsFor: 42,
    pointsAgainst: 42,
    result: 'D',
  },
  {
    event: 30,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'wadeland',
    pointsFor: 36,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 30,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'fent folders',
    pointsFor: 46,
    pointsAgainst: 36,
    result: 'W',
  },
  {
    event: 30,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Son Doku',
    pointsFor: 48,
    pointsAgainst: 49,
    result: 'L',
  },
  {
    event: 30,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Big Micha',
    pointsFor: 49,
    pointsAgainst: 48,
    result: 'W',
  },
  {
    event: 30,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Hookah Doncic',
    pointsFor: 35,
    pointsAgainst: 42,
    result: 'L',
  },
  {
    event: 30,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Chunky jeet FC',
    pointsFor: 42,
    pointsAgainst: 35,
    result: 'W',
  },
  {
    event: 31,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Real Manhattan',
    pointsFor: 50,
    pointsAgainst: 52,
    result: 'L',
  },
  {
    event: 31,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Son Doku',
    pointsFor: 52,
    pointsAgainst: 50,
    result: 'W',
  },
  {
    event: 31,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Hookah Doncic',
    pointsFor: 23,
    pointsAgainst: 23,
    result: 'D',
  },
  {
    event: 31,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'wadeland',
    pointsFor: 23,
    pointsAgainst: 23,
    result: 'D',
  },
  {
    event: 31,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Chunky jeet FC',
    pointsFor: 46,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 31,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'Yanited',
    pointsFor: 39,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 31,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Big Micha',
    pointsFor: 32,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 31,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'AVERAGE',
    pointsFor: 37,
    pointsAgainst: 32,
    result: 'W',
  },
  {
    event: 31,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'fent folders',
    pointsFor: 27,
    pointsAgainst: 29,
    result: 'L',
  },
  {
    event: 31,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'MBOOMO',
    pointsFor: 29,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 31,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Old Lady',
    pointsFor: 16,
    pointsAgainst: 28,
    result: 'L',
  },
  {
    event: 31,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 28,
    pointsAgainst: 16,
    result: 'W',
  },
  {
    event: 31,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Leyverpool',
    pointsFor: 19,
    pointsAgainst: 37,
    result: 'L',
  },
  {
    event: 31,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'A',
    pointsFor: 37,
    pointsAgainst: 19,
    result: 'W',
  },
  {
    event: 32,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'A',
    pointsFor: 48,
    pointsAgainst: 46,
    result: 'W',
  },
  {
    event: 32,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Real Manhattan',
    pointsFor: 46,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 32,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 26,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 32,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Leyverpool',
    pointsFor: 21,
    pointsAgainst: 26,
    result: 'L',
  },
  {
    event: 32,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'MBOOMO',
    pointsFor: 24,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 32,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Old Lady',
    pointsFor: 46,
    pointsAgainst: 24,
    result: 'W',
  },
  {
    event: 32,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'AVERAGE',
    pointsFor: 73,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 32,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'fent folders',
    pointsFor: 39,
    pointsAgainst: 73,
    result: 'L',
  },
  {
    event: 32,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Yanited',
    pointsFor: 40,
    pointsAgainst: 42,
    result: 'L',
  },
  {
    event: 32,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Big Micha',
    pointsFor: 42,
    pointsAgainst: 40,
    result: 'W',
  },
  {
    event: 32,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'wadeland',
    pointsFor: 27,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 32,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Chunky jeet FC',
    pointsFor: 39,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 32,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Son Doku',
    pointsFor: 33,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 32,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Hookah Doncic',
    pointsFor: 50,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 33,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Real Manhattan',
    pointsFor: 27,
    pointsAgainst: 64,
    result: 'L',
  },
  {
    event: 33,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'wadeland',
    pointsFor: 64,
    pointsAgainst: 27,
    result: 'W',
  },
  {
    event: 33,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Son Doku',
    pointsFor: 70,
    pointsAgainst: 61,
    result: 'W',
  },
  {
    event: 33,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'Yanited',
    pointsFor: 61,
    pointsAgainst: 70,
    result: 'L',
  },
  {
    event: 33,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Hookah Doncic',
    pointsFor: 51,
    pointsAgainst: 45,
    result: 'W',
  },
  {
    event: 33,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'AVERAGE',
    pointsFor: 45,
    pointsAgainst: 51,
    result: 'L',
  },
  {
    event: 33,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Chunky jeet FC',
    pointsFor: 39,
    pointsAgainst: 63,
    result: 'L',
  },
  {
    event: 33,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'MBOOMO',
    pointsFor: 63,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 33,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Big Micha',
    pointsFor: 37,
    pointsAgainst: 89,
    result: 'L',
  },
  {
    event: 33,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 89,
    pointsAgainst: 37,
    result: 'W',
  },
  {
    event: 33,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'fent folders',
    pointsFor: 41,
    pointsAgainst: 45,
    result: 'L',
  },
  {
    event: 33,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'A',
    pointsFor: 45,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 33,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Old Lady',
    pointsFor: 41,
    pointsAgainst: 48,
    result: 'L',
  },
  {
    event: 33,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'Leyverpool',
    pointsFor: 48,
    pointsAgainst: 41,
    result: 'W',
  },
  {
    event: 34,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Leyverpool',
    pointsFor: 16,
    pointsAgainst: 18,
    result: 'L',
  },
  {
    event: 34,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Real Manhattan',
    pointsFor: 18,
    pointsAgainst: 16,
    result: 'W',
  },
  {
    event: 34,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'A',
    pointsFor: 17,
    pointsAgainst: 13,
    result: 'W',
  },
  {
    event: 34,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Old Lady',
    pointsFor: 13,
    pointsAgainst: 17,
    result: 'L',
  },
  {
    event: 34,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 41,
    pointsAgainst: 19,
    result: 'W',
  },
  {
    event: 34,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'fent folders',
    pointsFor: 19,
    pointsAgainst: 41,
    result: 'L',
  },
  {
    event: 34,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'MBOOMO',
    pointsFor: 50,
    pointsAgainst: 47,
    result: 'W',
  },
  {
    event: 34,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Big Micha',
    pointsFor: 47,
    pointsAgainst: 50,
    result: 'L',
  },
  {
    event: 34,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'AVERAGE',
    pointsFor: 55,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 34,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'Chunky jeet FC',
    pointsFor: 31,
    pointsAgainst: 55,
    result: 'L',
  },
  {
    event: 34,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Yanited',
    pointsFor: 24,
    pointsAgainst: 21,
    result: 'W',
  },
  {
    event: 34,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Hookah Doncic',
    pointsFor: 21,
    pointsAgainst: 24,
    result: 'L',
  },
  {
    event: 34,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'wadeland',
    pointsFor: 38,
    pointsAgainst: 46,
    result: 'L',
  },
  {
    event: 34,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'Son Doku',
    pointsFor: 46,
    pointsAgainst: 38,
    result: 'W',
  },
  {
    event: 35,
    team: 'Yanited',
    manager: 'Akash',
    opponent: 'Real Manhattan',
    pointsFor: 22,
    pointsAgainst: 32,
    result: 'L',
  },
  {
    event: 35,
    team: 'Real Manhattan',
    manager: 'Teddy',
    opponent: 'Yanited',
    pointsFor: 32,
    pointsAgainst: 22,
    result: 'W',
  },
  {
    event: 35,
    team: 'AVERAGE',
    manager: 'AVERAGE',
    opponent: 'wadeland',
    pointsFor: 39,
    pointsAgainst: 49,
    result: 'L',
  },
  {
    event: 35,
    team: 'wadeland',
    manager: 'Arush',
    opponent: 'AVERAGE',
    pointsFor: 49,
    pointsAgainst: 39,
    result: 'W',
  },
  {
    event: 35,
    team: 'MBOOMO',
    manager: 'Raed',
    opponent: 'Son Doku',
    pointsFor: 26,
    pointsAgainst: 51,
    result: 'L',
  },
  {
    event: 35,
    team: 'Son Doku',
    manager: 'Jonathan',
    opponent: 'MBOOMO',
    pointsFor: 51,
    pointsAgainst: 26,
    result: 'W',
  },
  {
    event: 35,
    team: 'Shyam\u2019s Your Daddy',
    manager: 'Shyam',
    opponent: 'Hookah Doncic',
    pointsFor: 52,
    pointsAgainst: 55,
    result: 'L',
  },
  {
    event: 35,
    team: 'Hookah Doncic',
    manager: 'Arne',
    opponent: 'Shyam\u2019s Your Daddy',
    pointsFor: 55,
    pointsAgainst: 52,
    result: 'W',
  },
  {
    event: 35,
    team: 'A',
    manager: 'Ahmed',
    opponent: 'Chunky jeet FC',
    pointsFor: 30,
    pointsAgainst: 54,
    result: 'L',
  },
  {
    event: 35,
    team: 'Chunky jeet FC',
    manager: 'Ashaank',
    opponent: 'A',
    pointsFor: 54,
    pointsAgainst: 30,
    result: 'W',
  },
  {
    event: 35,
    team: 'Leyverpool',
    manager: 'Leyland',
    opponent: 'Big Micha',
    pointsFor: 31,
    pointsAgainst: 39,
    result: 'L',
  },
  {
    event: 35,
    team: 'Big Micha',
    manager: 'Hugh',
    opponent: 'Leyverpool',
    pointsFor: 39,
    pointsAgainst: 31,
    result: 'W',
  },
  {
    event: 35,
    team: 'Old Lady',
    manager: 'Nic',
    opponent: 'fent folders',
    pointsFor: 41,
    pointsAgainst: 33,
    result: 'W',
  },
  {
    event: 35,
    team: 'fent folders',
    manager: 'Rohit',
    opponent: 'Old Lady',
    pointsFor: 33,
    pointsAgainst: 41,
    result: 'L',
  },
]

export const teamMvps: Record<string, TeamMVP> = {
  'Real Manhattan': {
    player: 'Haaland',
    code: '223094',
    loadBearingWins: 6,
    totalPoints: 219.0,
    weeksRostered: 35,
  },
  MBOOMO: {
    player: 'B.Fernandes',
    code: '141746',
    loadBearingWins: 6,
    totalPoints: 209.0,
    weeksRostered: 35,
  },
  'Shyam’s Your Daddy': {
    player: 'Foden',
    code: '209244',
    loadBearingWins: 4,
    totalPoints: 115.0,
    weeksRostered: 35,
  },
  A: {
    player: 'Rice',
    code: '204480',
    loadBearingWins: 7,
    totalPoints: 176.0,
    weeksRostered: 35,
  },
  Leyverpool: {
    player: 'Thiago',
    code: '502500',
    loadBearingWins: 5,
    totalPoints: 175.0,
    weeksRostered: 35,
  },
  'Old Lady': {
    player: 'Ekitiké',
    code: '510663',
    loadBearingWins: 5,
    totalPoints: 125.0,
    weeksRostered: 34,
  },
  'fent folders': {
    player: 'Dewsbury-Hall',
    code: '215413',
    loadBearingWins: 5,
    totalPoints: 123.0,
    weeksRostered: 30,
  },
  'Big Micha': {
    player: 'Rogers',
    code: '244850',
    loadBearingWins: 3,
    totalPoints: 155.0,
    weeksRostered: 35,
  },
  'Chunky jeet FC': {
    player: 'Caicedo',
    code: '486672',
    loadBearingWins: 4,
    totalPoints: 105.0,
    weeksRostered: 35,
  },
  'Hookah Doncic': {
    player: 'Leno',
    code: '80201',
    loadBearingWins: 4,
    totalPoints: 111.0,
    weeksRostered: 35,
  },
  'Son Doku': {
    player: 'Pickford',
    code: '111234',
    loadBearingWins: 6,
    totalPoints: 129.0,
    weeksRostered: 35,
  },
  wadeland: {
    player: 'Bowen',
    code: '178186',
    loadBearingWins: 7,
    totalPoints: 171.0,
    weeksRostered: 35,
  },
  Yanited: {
    player: 'Tarkowski',
    code: '17761',
    loadBearingWins: 4,
    totalPoints: 149.0,
    weeksRostered: 35,
  },
}
